import React, { useContext, useEffect, useState } from "react";

import Avatar from "../components/avatar";
import Layout from "../components/layout";
import { navigate } from "gatsby";
import { useForm } from "react-hook-form";
import { MyFormContext } from "../context/form.context";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { formatCurrency } from "../utils";

const Step2 = () => {
  const { form, setForm } = useContext(MyFormContext);
  const { register, getValues, errors, formState } = useForm({
    mode: "onChange",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        if (!form.name || !form.phone || !form.email) {
          navigate("/step-1");
        } else {
          const data = await fetch("https://mindicador.cl/api/uf").then((r) => {
            return r.json();
          });

          setForm({ ...form, valorUf: parseFloat(data.serie[0].valor) });

          setLoading(false);
        }
      } catch {
        navigate("/step-1");
      }
    };

    getData();
  }, []);

  const changeInputs = () => {
    console.log(getValues().montoArriendo);
    var _montoArriendo = 0;
    if (
      getValues().montoArriendo !== "" &&
      parseFloat(getValues().montoArriendo) >= 199999
    ) {
      _montoArriendo = parseFloat(getValues().montoArriendo);
      const meses = parseInt(getValues().mes);
      const _montoGarantia = meses * _montoArriendo;
      const _primaBrutaAnual = (_montoGarantia / form.valorUf) * 0.12;
      const _totalPagar = _primaBrutaAnual + form.activacionCuenta;
      const _totalPagarApp = _totalPagar * form.valorUf;
      const _inmobilizacion = _montoGarantia - _totalPagarApp;
      setForm({
        ...form,
        montoArriendo: _montoArriendo,
        montoGarantia: _montoGarantia,
        primaBrutaAnual: _primaBrutaAnual,
        totalPagar: _totalPagar,
        totalPagarApp: _totalPagarApp,
        inmobilizacion: _inmobilizacion,
      });
    }
  };

  return (
    <Layout>
      <div className="container hero-body">
        <div className="content" style={{ minWidth: "300px" }}>
          {!loading && (
            <form>
              <div className="columns">
                <div className="column is-4 is-offset-1">
                  <label className="label">
                    <span className="is-capitalized">{form.name}</span>, por
                    favor ingresa el monto de arriendo de la propiedad
                  </label>
                  <div className="field">
                    <div
                      className="control has-icons-left"
                      style={{ paddingBottom: "0px" }}
                    >
                      <input
                        className={`input is-hovered ${errors.montoArriendo &&
                          "is-danger"}`}
                        name="montoArriendo"
                        ref={register({
                          required: "Required",
                          min: 199999,
                          validate: changeInputs,
                        })}
                        type="number"
                        placeholder=""
                        autoFocus
                      />
                      <span className="icon is-left prefix">$</span>

                      <span
                        className="help is-danger"
                        style={{ height: "10px" }}
                      >
                        {errors.montoArriendo &&
                          "Ingrese un monto mayor a $200.000 "}
                      </span>
                    </div>
                  </div>

                  <div className="control" onChange={changeInputs}>
                    <label className="radio">
                      <input
                        type="radio"
                        name="mes"
                        ref={register()}
                        value="1"
                      />{" "}
                      Simular 1 mes de garantía
                    </label>
                    <label className="radio">
                      <input
                        type="radio"
                        ref={register()}
                        defaultChecked
                        name="mes"
                        value="2"
                      />{" "}
                      Simular 2 meses de garantía
                    </label>
                  </div>
                  <br />
                  <label className="label">
                    Monto de garantía (Simulación para{" "}
                    {parseInt(getValues().mes)}{" "}
                    {parseInt(getValues().mes) === 1 ? "mes" : "meses"} de
                    Garantía)
                  </label>
                  <div className="field">
                    <div
                      className="control has-icons-left"
                      style={{ paddingBottom: "0px" }}
                    >
                      <input
                        className="input is-hovered"
                        type="text"
                        name="montoGarantia"
                        ref={register}
                        value={formatCurrency("CLP", form.montoGarantia)}
                        placeholder="0"
                        disabled
                      />
                      <span className="icon is-left prefix">$</span>
                    </div>
                  </div>

                  <label className="label">Prima Bruta Anual</label>
                  <div className="field">
                    <div className="control has-icons-left">
                      <input
                        name="primaBrutaAnual"
                        ref={register}
                        value={formatCurrency("UF", form.primaBrutaAnual)}
                        className="input is-hovered"
                        type="text"
                        placeholder="0"
                        disabled
                      />
                      <span className="icon is-left prefix">UF</span>
                    </div>
                    <div className="help-input-suffix">
                      * Nota: Este es un valor aproximado, el monto de la prima
                      bruta anual, estará sujeta a la evaluación del riesgo y
                      las condiciones de arriendo.
                    </div>
                  </div>

                  <label className="label">Activación de la cuenta</label>
                  <div className="field">
                    <div
                      className="control has-icons-left"
                      style={{ paddingBottom: "0px" }}
                    >
                      <input
                        name="activacionCuenta"
                        ref={register()}
                        className="input is-hovered prefix"
                        type="text"
                        value={formatCurrency("UF", form.activacionCuenta)}
                        disabled
                      />
                      <span className="icon is-left prefix">UF</span>
                    </div>
                  </div>

                  <label className="label">Total a pagar en UF</label>
                  <div className="field">
                    <div
                      className="control has-icons-left"
                      style={{ paddingBottom: "0px" }}
                    >
                      <input
                        name="totalPagar"
                        ref={register()}
                        className="input is-hovered"
                        type="text"
                        value={formatCurrency("UF", form.totalPagar)}
                        placeholder="0.00"
                        disabled
                      />
                      <span className="icon is-left prefix">UF</span>
                    </div>
                  </div>
                </div>
                <div className="column is-6 is-offset-1 has-text-centered">
                  <Avatar text="" />
                  <h5 className="subtitle is-5 ">
                    <span className="is-capitalized">{form.name}</span> tendrás
                    que pagar una Prima Bruta Anual de:
                  </h5>
                  <h1 className="title is-1 has-text-info pt-1 pb-1">
                    ${formatCurrency("CLP", form.totalPagarApp)}
                  </h1>

                  <h5 className="subtitle is-5 pt-3">
                    Con TrustRent no inmovilizarás:
                  </h5>
                  <h1 className="title is-1 has-text-danger  pt-1 pb-1">
                    ${formatCurrency("CLP", form.inmobilizacion)}
                  </h1>
                  <div className="is-size-12 has-text-centered">
                    <AniLink to="/step-3" cover direction="left" bg="#fec200">
                      <button
                        type="submit"
                        disabled={!formState.isValid}
                        className="button is-warning is-inverted is-outlined is-size-5"
                      >
                        SOLICITA TU COTIZACIÓN
                      </button>
                    </AniLink>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Step2;
